import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriesComponent } from './components/categories/categories.component';
import { ProductsComponent } from './components/products/products.component';
import { PartnerListComponent } from './components/grid/partner-list/partner-list.component';
import { AgGridModule } from 'ag-grid-angular';
import { RegStatusRendererComponent } from './components/cell-renderers/reg-status-renderer/reg-status-renderer.component';
import { VendorsListComponent } from './components/grid/vendors-list/vendors-list.component';
import { VendorAppListComponent } from './components/grid/vendor-app-list/vendor-app-list.component';
import { VendorAppPromotedRendererComponent } from './components/cell-renderers/vendor-app-promoted-renderer/vendor-app-promoted-renderer.component';
import { EditButtonRendererComponent } from './components/cell-renderers/edit-button-renderer/edit-button-renderer.component';
import { TiersListComponent } from './components/grid/tiers-list/tiers-list.component';
import { TierNameRendererComponent } from './components/cell-renderers/tier-name-renderer/tier-name-renderer.component';
import { CustomersListComponent } from './components/grid-store/customers-list/customers-list.component';
import { EnabledCustomerUsersComponent } from './components/grid-store/enabled-customer-users/enabled-customer-users.component';
import { UserConfigValueRendererComponent } from './components/grid-store-cell-renderers/user-config-value-renderer/user-config-value-renderer.component';
import { FormsModule } from '@angular/forms';
import { EnabledDomainUsersComponent } from './components/grid-store/enabled-domain-users/enabled-domain-users.component';
import { DomainConfigValueRendererComponent } from './components/grid-store-cell-renderers/domain-config-value-renderer/domain-config-value-renderer.component';
import { DomainListComponent } from './components/grid-store/domain-list/domain-list.component';
import { CustomGridPaginationComponent } from './components/custom-grid-pagination/custom-grid-pagination.component';
import { ResourceNameFilterComponent } from './components/custom-filters/audit-logs/resource-name-filter/resource-name-filter.component';
import { UserIdFilterComponent } from './components/custom-filters/audit-logs/user-id-filter/user-id-filter.component';
import { UpdatedFilterComponent } from './components/custom-filters/audit-logs/updated-filter/updated-filter.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppNameFilterComponent } from './components/custom-filters/app-states/app-name-filter/app-name-filter.component';
import { PartnerNameFilterComponent } from './components/custom-filters/app-states/partner-name-filter/partner-name-filter.component';
import { StatesFilterComponent } from './components/custom-filters/app-states/states-filter/states-filter.component';
import { ResourceTypeFilterComponent } from './components/custom-filters/audit-logs/resource-type-filter/resource-type-filter.component';

import { DomainNameFilterComponent } from './components/custom-filters/app-states/domain-name-filter/domain-name-filter.component';
import { RefreshBtnComponent } from './components/refresh-btn/refresh-btn.component';
import { CategorySelectComponent } from './components/category-select/category-select.component';
import { AuditLogsComponent } from './components/grid-server-side/audit-logs/audit-logs.component';
import { AppStatesStaticComponent } from './components/grid/app-states-static/app-states-static.component';
import { CheckRevokeStateComponent } from './components/check-revoke-state/check-revoke-state.component';
import { CheckRevokeStateOmComponent } from './components/check-revoke-state-om/check-revoke-state-om.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SearchBoxComponent } from './components/search-box/search-box.component';
import { AlertBoxComponent } from './components/alert-box/alert-box.component';
import { WebHookFormComponent } from './components/web-hook-form/web-hook-form.component';
import { WebHookCustomFieldsComponent } from './components/web-hook-custom-fields/web-hook-custom-fields.component';
import { WfLogsComponent } from './components/grid-server-side/wf-logs/wf-logs.component';
import { WfNameFilterComponent } from './components/custom-filters/wf-logs/wf-name-filter/wf-name-filter.component';
import { WfTaskFilterComponent } from './components/custom-filters/wf-logs/wf-task-filter/wf-task-filter.component';
import { WfStatusFilterComponent } from './components/custom-filters/wf-logs/wf-status-filter/wf-status-filter.component';
import { EditDeleteButtonRendererComponent } from './components/grid-store-cell-renderers/edit-delete-button-renderer/edit-delete-button-renderer.component';
import { UserEditDeleteButtonRendererComponent } from './components/grid-store-cell-renderers/user-edit-delete-button-renderer/user-edit-delete-button-renderer.component';
import { VendorAppsComponent } from './components/grid-server-side/vendor-apps/vendor-apps.component';
import { PartnerActionRendererComponent } from './components/cell-renderers/partner-action-renderer/partner-action-renderer.component';
import { EnabledAppsGridComponent } from './components/grid/enabled-apps-grid/enabled-apps-grid.component';
import { UpdateCspComponent } from './components/update-csp/update-csp.component';
import { AppsGridComponent } from './components/grid-server-side/apps/apps-grid.component';
import { AppNameTextFilterComponent } from './components/custom-filters/apps/app-name-text-filter/app-name-text-filter.component';

@NgModule({
  declarations: [

    CategoriesComponent,
    ProductsComponent,
    PartnerListComponent,
    RegStatusRendererComponent,
    VendorsListComponent,
    VendorAppListComponent,
    VendorAppPromotedRendererComponent,
    EditButtonRendererComponent,
    TiersListComponent,
    TierNameRendererComponent,
    CustomersListComponent,
    EnabledCustomerUsersComponent,
    UserConfigValueRendererComponent,
    EnabledDomainUsersComponent,
    DomainConfigValueRendererComponent,
    DomainListComponent,
    CustomGridPaginationComponent,
    ResourceNameFilterComponent,
    UserIdFilterComponent,
    UpdatedFilterComponent,
    AppNameFilterComponent,
    PartnerNameFilterComponent,
    StatesFilterComponent,
    ResourceTypeFilterComponent,
    AuditLogsComponent,
    DomainNameFilterComponent,
    RefreshBtnComponent,
    CategorySelectComponent,
    AppStatesStaticComponent,
    CheckRevokeStateComponent,
    CheckRevokeStateOmComponent,
    SafeHtmlPipe,
    SearchBoxComponent,
    AlertBoxComponent,
    WebHookFormComponent,
    WebHookCustomFieldsComponent,
    WfLogsComponent,
    VendorAppsComponent,
    WfNameFilterComponent,
    WfTaskFilterComponent,
    WfStatusFilterComponent,
    EditDeleteButtonRendererComponent,
    UserEditDeleteButtonRendererComponent,
    PartnerActionRendererComponent,
    EnabledAppsGridComponent,
    UpdateCspComponent,
    AppsGridComponent,
    AppNameTextFilterComponent
  ],
  imports: [
    CommonModule,
    AgGridModule,
    FormsModule,
    NgbModule
  ],
  exports: [CategoriesComponent, VendorAppListComponent,
    ProductsComponent, PartnerListComponent, VendorsListComponent, TiersListComponent,
    CustomersListComponent, DomainListComponent,
    EnabledCustomerUsersComponent, EnabledDomainUsersComponent, CustomGridPaginationComponent,
    ResourceNameFilterComponent, UserIdFilterComponent, UpdatedFilterComponent,
    AppStatesStaticComponent, EditDeleteButtonRendererComponent, UserEditDeleteButtonRendererComponent,
    AppNameFilterComponent, PartnerNameFilterComponent, StatesFilterComponent, ResourceTypeFilterComponent,
    AuditLogsComponent, DomainNameFilterComponent, RefreshBtnComponent, CategorySelectComponent, WebHookFormComponent,
    WebHookCustomFieldsComponent, WfLogsComponent, VendorAppsComponent, WfNameFilterComponent, WfTaskFilterComponent, WfStatusFilterComponent,
    CheckRevokeStateComponent, CheckRevokeStateOmComponent, SafeHtmlPipe, SearchBoxComponent, AlertBoxComponent, PartnerActionRendererComponent,
  EnabledAppsGridComponent, UpdateCspComponent, AppsGridComponent, AppNameTextFilterComponent],
  // providers: [authInterceptorProviders],
})
export class SharedModule { }
